import React from "react";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../Utils/format-date.js";
import { addInviteesButton } from "../../../Utils/addinviteesButton";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import completed from "../../../../images/completed.png";
import MyinvitationsEmpty from "../Invitations-Empty";
import "./Received-Tab.css";

const ReceivedTab = (props) => {
  return (
    <React.Fragment>
      {props.receivedInvitations.length == 0 ? (
        <MyinvitationsEmpty />
      ) : (
        <React.Fragment>
          {props.receivedInvitations.map((details, index) => {
            return (
              <div className="resopnsive-received-tab mb-4" key={index}>
                <Row onClick={() => props.toggleCollapse(details.id)} className="responsive-sent-tabRow">
                  <p className="head-name">
                    {details.user_assessment__participant__full_name}
                    <span style={{ textTransform: "lowercase" ,marginRight:'5px'}}>'s</span> {details.user_assessment__instrument__instrument_name}
                  </p>
                  <i
                    className={props.collapseID === details.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                    aria-hidden="true"
                  />
                </Row>
                <hr />
                <Collapse isOpen={props.collapseID === details.id}>
                  <CardBody style={{padding:"5px"}}>
                    <Row>
                      <Col className="title">From</Col>
                      <Col className="info">
                        {details.user_assessment__participant__full_name}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Relationship</Col>
                      <Col className="info">
                        {details.assessor_group__assessor_name}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Date of Expiry</Col>
                      <Col className="info">
                        {formatDate(details.user_assessment__expiry_date)}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="title">Status</Col>
                      <Col className="status-col">
                        {details.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                details.assessment_status__status_name
                              )
                            }
                          >
                            {details.assessment_status__status_name}
                            {calcPercentage(
                              details.user_assessment__assessment_number_count,
                              details.respondent_completed_count
                            )}
                          </div>
                        ) : details.assessment_status__status_name ===
                          "Completed" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                details.assessment_status__status_name
                              )
                            }
                          >
                            {details.assessment_status__status_name}
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                details.assessment_status__status_name
                              )
                            }
                          >
                            {details.assessment_status__status_name}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <hr />
                    <Row>{addInviteesButton(details)}</Row>
                  </CardBody>
                </Collapse>
              </div>
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ReceivedTab;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Responsive/Received-Tab.jsx